import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import React from "react";

import { Props } from "./interfaces";
import { Container, DocumentRequestsContainer } from "./styles";
import AddNewDocument from "../../../../containers/AddNewDocument/AddNewDocument";
import AttachedDocuments from "../../../../containers/AttachedDocuments/AttachedDocuments";
import { DocumentRef } from "../../../../models/documents/document-ref";
import { Period, PeriodType } from "../../../../models/documents/period/period";
import { DocumentRequestDTO } from "../../../../models/employee-document-requests/document-request-dto";
import { handleDownloadDocsFiles } from "../../../../services/documents/document-files-api.service";
import { EmployeesDocRequestsApiService } from "../../../../services/employees/employees-doc-requests-api.service";

const DocumentRequests = ({ docRequests, notifyParent }: Props) => {
  // simulate page number change to reload
  const updateDocRequest = async (docRequest: DocumentRequestDTO, document: DocumentRef | null): Promise<void> => {
    try {
      const serviceApiInstance = new EmployeesDocRequestsApiService();
      docRequest.document = document;

      const { isSucceeded } = await serviceApiInstance.saveItems([docRequest]);

      if (isSucceeded && notifyParent) notifyParent();
    } catch (error) {
      console.log("Error updating document request:", error);
    }
  };

  return (
    <Container>
      {docRequests &&
        docRequests.length > 0 &&
        docRequests.map((docRequest, idx) => (
          <DocumentRequestsContainer
            key={docRequest.id}
            title={`Request to upload ${docRequest.requestType?.description}`}
          >
            <Typography
              onClick={() => {
                if (docRequest.document && docRequest.document.filesCount > 0)
                  handleDownloadDocsFiles([docRequest.document.id]);
              }}
            >
              {`${idx + 1}/ `}
            </Typography>
            {docRequest.document && docRequest.document.filesCount > 0 && (
              <IconButton
                size="small"
                onClick={() => {
                  if (docRequest.document && docRequest.document.filesCount > 0)
                    handleDownloadDocsFiles([docRequest.document.id]);
                }}
              >
                <FontAwesomeIcon icon={faDownload} />
              </IconButton>
            )}
            {docRequest.document ? (
              <AttachedDocuments
                documentIDs={[docRequest.document.id]}
                count={docRequest.document?.filesCount}
                buttonSize="1x"
                handleNotifyParent={notifyParent}
                isWidget
                documentsNames={[docRequest.document?.name]}
              />
            ) : (
              <AddNewDocument
                // openButtonKey={`+`}
                isWidget
                // linkStyles
                buttonType="plusButton"
                documentName={`${docRequest.requestType?.name}: ${docRequest.employee?.name}`}
                isPredefinedDocName
                documentFieldsProps={{
                  category: docRequest?.requestType?.documentType?.category,
                  legalEntity: docRequest?.employee?.legalEntity,
                  type: docRequest?.requestType?.documentType,
                  employee: docRequest.employee,
                  period: Period.makePeriod(new Date().getFullYear(), PeriodType.Month, new Date().getMonth() + 1),
                  documentDate: new Date(),
                }}
                useMiniPlusButton
                handleNotifyParent={(document) => updateDocRequest(docRequest, document)}
              />
            )}
          </DocumentRequestsContainer>
        ))}
    </Container>
  );
};

export default DocumentRequests;
